import styled from 'foundations-theming/utils';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledList = styled.div.withConfig({
  displayName: "AtMentionSuggestionsComponent__StyledList"
})(["inline-size:100%;background-color:var(--trellis-color-fill-surface-default);border-radius:4px;[data-suggestion-item='true']{padding:8px;cursor:pointer;&[data-suggestion-disabled='true']{color:var(--trellis-color-text-core-disabled);cursor:not-allowed;}}[data-suggestion-active='true']{background-color:var(--trellis-color-fill-field-hover);}"]);
const StyledItem = styled.div.withConfig({
  displayName: "AtMentionSuggestionsComponent__StyledItem"
})(["display:flex;align-items:center;gap:8px;"]);
const TeamLabel = styled.span.withConfig({
  displayName: "AtMentionSuggestionsComponent__TeamLabel"
})(["font-size:10px;font-weight:600;color:var(--trellis-color-text-core-subtle);text-transform:uppercase;flex-shrink:0;"]);
export function AtMentionSuggestionsComponent({
  suggestions,
  text,
  NotFoundComponent
}) {
  const mentionSuggestions = suggestions;
  return /*#__PURE__*/_jsx(StyledList, {
    "data-suggestion-item-list": "true",
    children: !(mentionSuggestions !== null && mentionSuggestions !== void 0 && mentionSuggestions.length) ? NotFoundComponent ? /*#__PURE__*/_jsx("div", {
      style: {
        padding: '16px'
      },
      children: /*#__PURE__*/_jsx(NotFoundComponent, {
        text: text
      })
    }) : null : mentionSuggestions.map((item, index) => {
      const isDisabled = Boolean(item.disabled);
      const disabledTitle = isDisabled && item.type === 'TEAM' ? I18n.text('atMentionPlugin.disabledTeamTooltip', {
        name: item.searchText
      }) : undefined;
      return /*#__PURE__*/_jsx("div", {
        "data-suggestion-item": "true",
        "data-suggestion-disabled": isDisabled,
        tabIndex: 0
        // TODO: title tooltip is not rendered because this component is rendered via
        // ReactDOMServer.renderToString in MentionsPlugin — needs fix at the plugin layer
        ,
        title: disabledTitle,
        children: /*#__PURE__*/_jsxs(StyledItem, {
          children: [item.type === 'TEAM' && /*#__PURE__*/_jsx(TeamLabel, {
            children: "Team"
          }), /*#__PURE__*/_jsx("span", {
            style: {
              color: isDisabled ? 'var(--trellis-color-text-core-disabled)' : undefined
            },
            children: item.searchText
          })]
        })
      }, index);
    })
  });
}